export class SearchUrl {
  
  baseUrl: string;
  selectionUrl: string[];
  sortOrder: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.selectionUrl = [];
    this.sortOrder = '';
  }

  getUrl() {
    let parameters = this.selectionUrl;
    if (this.sortOrder != ''){
      parameters = parameters.concat('sort=' + this.sortOrder);
    }
    const parameterString =  (parameters.length > 0) ? '?' + parameters.join('&') : '';
    return this.baseUrl + parameterString;
  }
}